import { createSuppressionStore } from "./createSuppressionStore";

const zeffyLauncherSuppression = createSuppressionStore();

export const useZeffyLauncherSuppressed = zeffyLauncherSuppression.useSuppressed;

export const useSuppressZeffyLauncher = zeffyLauncherSuppression.useSuppress;
